import slugify from 'slugify';

export const getSectionId = data =>
  slugify(data?.nav_link_title || '', { lower: true });
